import customers from "./customers.svg";
import productCatalog from "./productCatalog.svg";
import invoices from "./invoices.svg";
import purchases from "./purchases.svg";
import templates from "./templates.svg";
import discounts from "./discounts.svg";

const Icons = { customers, productCatalog, invoices, purchases, templates, discounts };

export default Icons;
